module.exports = __webpack_public_path__ + "img/logo-white.dc8203c8.png";